const getUser = () => {
  const userString = window.localStorage.getItem('gatsbyUser')
  if (userString) {
    const user = JSON.parse(userString)
    return user || {}
  }
  return {}
}

export default getUser
